import * as axiosService from "./axiosService";

export const getAccountDetails = (userId) => {
    const queryParams = [];
    if (userId) {
        queryParams.push(`userId=${userId}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/GetBasicInfo${queryString}`);

};

export const saveProfileDetails = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/SaveProfileInfo`,payload);
};

export const getSupplierKycInfo = (userId) => {
    const queryParams = [];
    if (userId) {
        queryParams.push(`userId=${userId}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/GetKYCDetailsForUserProfile${queryString}`);
};

export const saveKYCInfo = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/SaveKYCDetailsForUserProfile`, payload);
};

export const getUserDetail=()=>{
    // return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/UserDetail`);
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/UserDetail?isForQuietHour=true`);
}

export const saveRequestUpgrade = () => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Driver/RequestUpgrade`,'');
};